import Rest from './rest';


export default {

    auth: function (objectParams) {
        return Rest.post(`/auth` , objectParams, false);
    },

    authInfo: function () {
        return Rest.get(`/me`)
    },

    fbCustomToken: function () {
        return Rest.get("/fbtoken")
    }

};



// WEBPACK FOOTER //
// ./src/services/AuthService.js